import { Injectable } from '@angular/core';
import { EntityTypeCode } from './system-type-constants';
@Injectable()
export class EntityIdFormatterService {
  getFormattedId(id: any, prefix: string): string {
    if (!id || !prefix) {
      return '';
    }
    const idStr = id.toString().padStart(9, '0');
    const formattedId = idStr.replace(/(\d{2})(\d{4})(\d{3})/, '$1-$2-$3');
    return `${prefix.toUpperCase()}-${formattedId}`;
  }

  getNumericId(entityId: string): number {
    // ID must be in the format XX-00-0001-001 or XX000001001
    if (!entityId || (entityId.length !== 14 && entityId.length !== 11)) {
      throw Error('Invalid Entity ID: ' + entityId);
    }
    entityId = entityId.substr(2).replace(/-+/g, '');
    const parsed = parseInt(entityId, 10);
    if (isNaN(parsed)) {
      throw Error('Invalid Entity ID: ' + entityId);
    }

    return parsed;
  }

  formatWNumberOrTNumber(entityId: string, entityTypeCode: EntityTypeCode) {
    if (entityId) {
      if (!entityId.startsWith('W') && !entityId.startsWith('T')) {
        if (entityTypeCode === EntityTypeCode.Insurer) {
          return 'W' + entityId;
        } else {
          return 'T' + entityId;
        }
      }
      return entityId;
    }
    return '';
  }
}
